import { useState } from 'react';
import { Menu, X, ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import '../../../styles/LandingIntegrated.css';

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <motion.nav 
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="li-navbar"
    >
      <div className="li-container" style={{ width: '100%', maxWidth: '1400px' }}>
        <div className="li-nav-inner" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
          
          {/* Logo - Far Left */}
          <div style={{ flex: '0 0 auto' }}>
            <Link to="/" className="li-flex li-items-center li-gap-3">
              <img src="/Images/trueExams_logo.png" alt="trueExams Logo" className="li-nav-logo" style={{ height: '2.5rem' }} />
            </Link>
          </div>

          {/* Menu - Center (Desktop only) */}
          {isHomePage && (
            <div className="li-nav-links li-md-flex" style={{ flex: '1 1 auto', justifyContent: 'center', gap: '3rem' }}>
              <a href="#features" className="li-nav-link" style={{ fontSize: '1rem', fontWeight: 600 }}>Features</a>
              <a href="#roles" className="li-nav-link" style={{ fontSize: '1rem', fontWeight: 600 }}>Solutions</a>
              <a href="#pricing" className="li-nav-link" style={{ fontSize: '1rem', fontWeight: 600 }}>Pricing</a>
            </div>
          )}

          {/* Actions - Far Right */}
          <div className="li-flex li-items-center li-gap-6" style={{ flex: '0 0 auto', justifyContent: 'flex-end' }}>
            {isHomePage ? (
              <>
                <button className="li-nav-btn li-md-flex" style={{ padding: '0.75rem 2rem', fontSize: '0.9rem' }}>
                  Download App
                </button>
                <button onClick={() => setMobileMenu(!mobileMenu)} className="li-mobile-toggle">
                  {mobileMenu ? <X size={28} /> : <Menu size={28} />}
                </button>
              </>
            ) : (
              <Link 
                to="/" 
                className="li-nav-link li-flex li-items-center li-gap-2"
                style={{ fontSize: '1rem', fontWeight: 600 }}
              >
                <ArrowLeft size={20} />
                Back to Home
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenu && isHomePage && (
          <motion.div 
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            style={{ backgroundColor: 'white', borderTop: '1px solid #f3f4f6', padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}
          >
            <a href="#features" className="li-nav-link" onClick={() => setMobileMenu(false)} style={{ fontSize: '1.25rem' }}>Features</a>
            <a href="#roles" className="li-nav-link" onClick={() => setMobileMenu(false)} style={{ fontSize: '1.25rem' }}>Solutions</a>
            <a href="#pricing" className="li-nav-link" onClick={() => setMobileMenu(false)} style={{ fontSize: '1.25rem' }}>Pricing</a>
            <button className="li-nav-btn" style={{ width: '100%', padding: '1rem' }}>Download App</button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
